import { render, staticRenderFns } from "./editProductsOpeningBalance.vue?vue&type=template&id=151788ee"
import script from "./editProductsOpeningBalance.vue?vue&type=script&lang=js"
export * from "./editProductsOpeningBalance.vue?vue&type=script&lang=js"
import style0 from "./editProductsOpeningBalance.vue?vue&type=style&index=0&id=151788ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports